import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

import { UsersService } from '@shared/services/users.service';
import { ClientAccountService } from '@shared/services/client-account.service';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

  constructor(
    private oauthService: OAuthService,
    private usersService: UsersService,
    private clientAccountService: ClientAccountService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let accessToken: string = this.oauthService.getAccessToken();
    let authReq;
    // NO TOKEN TO IDP, IS STUPID
    if (req.url.includes('idp')) {
      return next.handle(req);
    }
    // NO TOKEN FOR LANGUAGES TO NOT CHANGE BACKEND CLIENT
    if (req.url.includes('mldr')) {
      return next.handle(req);
    }
    if (req.url.includes('openid') && accessToken) {
      console.log('refresh del tokennnnnnnnn');
      authReq = req.clone({
        setHeaders: {
          authorization: 'Bearer ' + accessToken,
        }
      });
    } else if (this.usersService.getUser()) {
      authReq = req.clone({
        setHeaders: {
          authorization: 'Bearer ' + accessToken,
          appId: this.usersService.getUser()?.appId,
          uida: this.usersService.getUser()?.uida,
          unit: this.currentUnit(),
          unitCode: this.currentUnit(),
        },
      });
    } else {
      authReq = req.clone({
        setHeaders: {
          authorization: 'Bearer ' + accessToken,
        }
      });
    }

    return next.handle(authReq);
  }

  currentUnit(): string {
    if (this.clientAccountService.getAccount()) {
      return this.clientAccountService.getAccount().accountCode;
    } else if(this.clientAccountService.getClient()) {
      return this.clientAccountService.getClient().customerCode;
    }
    return this.usersService.getUser()?.aggregations[0]?.unit;
  }

  // private handleAuthError(err: HttpErrorResponse): Observable<any> {
  //   console.log(err, 'handle error token interceptor');
  //   //handle your auth error or rethrow
  //   if (err.status === 401 || err.status === 403) {
  //     this.redirectTimeout = setTimeout(() => {
  //       window.location.assign(authConfig.redirectUri);
  //     }, 100);
  //     // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
  //     return of(err.message); // or EMPTY may be appropriate here
  //   }
  //   return throwError(err);
  // }
}

export const HttpTokenInterceptorProvider: any = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpTokenInterceptor,
  multi: true,
};
